import React from 'react';
import styled, { css } from 'styled-components';
import { comma } from '@zillow/formatters';
import { token, Text, Popper, Popover, Heading, mediaMixin, spaceMixin, Paragraph, Flex } from '@zillow/constellation';
var StyledDiv = styled.div.withConfig({
  displayName: "HomeValue__StyledDiv",
  componentId: "sc-if6fgm-0"
})(["background-color:", ";border-style:solid;border-radius:3px;border-width:1px;border-color:", ";padding:", " ", ";", ";"], token('colors.white'), token('colors.gray300'), spaceMixin(3), spaceMixin(2), mediaMixin('md_lte', css(["padding:", ";"], spaceMixin(1.25))));
var StyledPopper = styled(Popper).withConfig({
  displayName: "HomeValue__StyledPopper",
  componentId: "sc-if6fgm-1"
})(["bottom:", ";left:", ";"], spaceMixin(0.4), spaceMixin(0.5));
var Buffer = styled.div.withConfig({
  displayName: "HomeValue__Buffer",
  componentId: "sc-if6fgm-2"
})(["border-bottom:2px dashed ", ";flex:1;margin:0 ", " ", ";"], token('colors.gray300'), spaceMixin(1.25), spaceMixin(0.5));

function TooltipContent() {
  return /*#__PURE__*/React.createElement(Paragraph, null, "A ", /*#__PURE__*/React.createElement("b", null, "Zestimate\xAE"), " home valuation is Zillow\u2019s estimated market value. It is not an appraisal. Use it as a starting point to determine a home\u2019s value.", ' ', /*#__PURE__*/React.createElement("a", {
    href: "/zestimate"
  }, "Learn more"));
}

var HomeValue = function HomeValue(_ref) {
  var zestimate = _ref.zestimate;
  return /*#__PURE__*/React.createElement(StyledDiv, {
    "data-testid": "home-value"
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "h6"
  }, "Your home value"), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    marginTop: "sm",
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "h5",
    fontColor: "textDark"
  }, "Zestimate"), /*#__PURE__*/React.createElement(StyledPopper, {
    triggered: /*#__PURE__*/React.createElement(Popover, {
      header: /*#__PURE__*/React.createElement(Heading, {
        level: 6
      }, "Zestimate"),
      body: /*#__PURE__*/React.createElement(TooltipContent, null)
    })
  }), /*#__PURE__*/React.createElement(Buffer, null), /*#__PURE__*/React.createElement(Text, {
    fontType: {
      default: 'h5',
      md: 'h4'
    },
    fontColor: "textDark"
  }, zestimate ? "$" + comma(zestimate) : 'N/A')));
};

export default HomeValue;
//# sourceMappingURL=HomeValue.js.map